<template>
  <div id="app">
    <div id="nav"></div>
     <!-- v-wechat-title="$route.meta.title" -->
      <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>
<script>
    export default {
        provide: {
            //图片编辑全局配置参数
            imgEditConfig: {
                curPmNumber:'',//项目编号
                title:'',//标题
                showPopup: false,
                url: "",
                result: "",
                pointTypeArr: [],
                fullScreen:true,
            }
        }
    }
</script>
<style lang="scss" >
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
